import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { ResetStateDefaults } from '../../../base-action-class.model';
import { RAccessRights } from './r-access-rights.action';

interface RAccessRightsXsStateModel{
  viewAllAccessRights: string;
}

const getDefaults = (): RAccessRightsXsStateModel => ({
  viewAllAccessRights: null,
});

@State<RAccessRightsXsStateModel>({
  name: 'rAccessRights',
  defaults: getDefaults()
})
@Injectable()
export class RAccessRightsXsState{

  //region SELECTOR

  @Selector()
  static canViewAllAccessRights(state: RAccessRightsXsStateModel): boolean {
    return state.viewAllAccessRights != null;
  }

  //endregion

  //region ACTIONS
  @Action(RAccessRights.SetAccessRightsPrivileges)
  public setAccessRightsPrivileges(ctx: StateContext<RAccessRightsXsStateModel>, action: RAccessRights.SetAccessRightsPrivileges) {
    const state = ctx.getState();
    const accessRightsPrivileges = [...action.activeUserRightInfoDtoModel.accessRightsPrivileges];

    //find user privilege data model
    const viewAllAccessRights = accessRightsPrivileges.find(id => id === UserPrivilegeEnum.VIEW_ALL_ACCESS_MAPPINGS);

    //set the state
    ctx.setState({
      ...state,
      viewAllAccessRights: viewAllAccessRights,
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RAccessRightsXsStateModel>): void {
    ctx.setState({...getDefaults()});
  }
  //endregion
}
